import {
	usePermissions, useNotify, useRedirect, useTranslate,
	TopToolbar, ListButton, Edit,
	SimpleForm, TextInput
} from 'react-admin';
import { Helmet } from 'react-helmet-async';

const CustomActions = () => (
	<TopToolbar>
		<ListButton />
	</TopToolbar>
);

export const UserEdit = () => {
	const translate = useTranslate();
	const { permissions, isLoading } = usePermissions();
	const notify = useNotify();
	const redirect = useRedirect();
	
	const pageTitle = translate('resources.user.edit');
	const systemName = translate('system.name');
	
	if (isLoading) return null;
	
	if (permissions !== 'admin') {
		notify('この機能にアクセスする権限がありません', { type: 'warning' });
		redirect('/user');
		return null;
	}
	
	return (
		<>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<Edit actions={<CustomActions />} title={pageTitle} queryOptions={{ meta: { mode: 'kanri' } }} mutationOptions={{ meta: { mode: 'kanri' } }}>
				<SimpleForm>
					<TextInput source="id" disabled />
					<TextInput source="name" />
				</SimpleForm>
			</Edit>
		</>
	);
};

export default UserEdit;
